import { useQuery } from '@tanstack/react-query';

import { getMediaLibrary, type MediaLibraryParams } from '../media.api';

/**
 * Queries the customer's DAM library (h11-1). Filters come from the list state of the caller
 * (MediaLibraryPage) — this hook only turns a filter object into a TanStack Query cache
 * entry, keyed so every distinct filter combination gets its own cached page. Het
 * klantnummer zit in die sleutel, zodat een medewerker die van klant wisselt niet de
 * bibliotheek van de vorige klant terugziet.
 *
 * `enabled` staat uit zolang er geen klant bekend is: dan zou de server terecht weigeren,
 * en een foutmelding zegt de gebruiker minder dan het scherm dat vraagt om een klant.
 */
export function useMediaLibrary(params: MediaLibraryParams, enabled = true) {
  const query = useQuery({
    queryKey: ['media', 'library', params],
    queryFn: () => getMediaLibrary(params),
    staleTime: 60 * 1000,
    enabled,
  });

  const items = query.data?.data ?? [];
  const meta = query.data?.meta ?? { total: 0, page: params.page, pageSize: params.pageSize, degraded: false, brands: [] };

  return { ...query, items, meta };
}
